import { render, staticRenderFns } from "./withdrawPermissions.vue?vue&type=template&id=71afc701"
import script from "./withdrawPermissions.vue?vue&type=script&lang=js"
export * from "./withdrawPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports